import gql from "graphql-tag";
const signInToForum = gql(` 
query signInToForum($username: String!, $email: String!, $avatar: String! ) {
  signInToForum(username: $username, email: $email, avatar: $avatar) {
  result
  } 
}   
`)
export default signInToForum;
